import React from 'react';
import '../assets/styles/modal.css';

const AccountVerifiedModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <button className="modal-close" onClick={onClose}>&times;</button>

                {/* Icono de éxito animado */}
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <div style={{
                        width: '100px',
                        height: '100px',
                        margin: '0 auto 20px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 8px 30px rgba(16, 185, 129, 0.4)',
                        animation: 'pulse 2s ease-in-out infinite'
                    }}>
                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                    <h2 style={{ color: '#10b981', marginBottom: '10px', fontSize: '1.8rem', fontWeight: 'bold' }}>
                        ¡Cuenta Verificada!
                    </h2>
                    <p style={{ color: '#666', fontSize: '1rem' }}>
                        Tu cuenta bancaria ha sido verificada exitosamente
                    </p>
                </div>

                {/* Beneficios desbloqueados */}
                <div style={{
                    background: 'rgba(16, 185, 129, 0.1)',
                    border: '1px solid rgba(16, 185, 129, 0.3)',
                    borderRadius: '10px',
                    padding: '25px',
                    marginBottom: '25px'
                }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '20px', color: '#059669', textAlign: 'center' }}>
                        Funciones Desbloqueadas
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <span style={{ fontSize: '1.2rem', color: '#fff' }}>$</span>
                            </div>
                            <div>
                                <div style={{ fontWeight: 'bold', color: '#333', marginBottom: '3px' }}>Retiros Habilitados</div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>Retira tus fondos a tu cuenta bancaria</div>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <span style={{ fontSize: '1.2rem', color: '#fff' }}>✓</span>
                            </div>
                            <div>
                                <div style={{ fontWeight: 'bold', color: '#333', marginBottom: '3px' }}>Cuenta Segura</div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>Tu identidad ha sido verificada</div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <span style={{ fontSize: '1.2rem', color: '#fff' }}>→</span>
                            </div>
                            <div>
                                <div style={{ fontWeight: 'bold', color: '#333', marginBottom: '3px' }}>Operaciones Rápidas</div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>Acceso completo a todas las funciones</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mensaje de bienvenida */}
                <div style={{
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    padding: '20px',
                    marginBottom: '20px',
                    textAlign: 'center'
                }}>
                    <p style={{ margin: 0, color: '#333', lineHeight: '1.6' }}>
                        Ya puedes disfrutar de todas las funcionalidades de XCoin. 
                        ¡Gracias por confiar en nosotros!
                    </p>
                </div>

                {/* Botón de cierre */}
                <button
                    onClick={onClose}
                    style={{
                        width: '100%',
                        padding: '15px',
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                    }}
                >
                    ¡Comenzar a Operar!
                </button>

                <style>{`
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                        }
                        50% {
                            transform: scale(1.05);
                        }
                    }
                `}</style>
            </div>
        </div>
    );
};

export default AccountVerifiedModal;
